/*function capitalize(input) {
  const tokens = input.replace(/\s+/g, ' ').split(' ');
  const output = tokens.map(function(token) {
    return token[0].toUpperCase() + token.slice(1).toLowerCase();
  });

  return output.join(' ');
}*/

var added_items = [];
$(function() {
    //save venueId from dom for backend us
    const venueId = $('#venue-id').text().trim();
    const venue_slug = $('#venue-slug').text().trim();
    const venueName = $('#venue-name').text().trim();
    const userId = $('#user-id').text().trim() ? $('#user-id').text().trim() : false;
    const ITEMS_ADDED = [];
    var ITEMS_INFO = [];

    document.getElementById('addMenuButton').onclick = function(e) {
        e.preventDefault();
        $('#addMenuInput').fadeIn().find('#menu-input').get(0).focus();
        $('#addMenuButton').hide();
        $('#menu-input').focus();
    };

    document.getElementById('addSectionButton').onclick = function(e) {
        e.preventDefault();
        $('#addSectionInput').fadeIn().find('#menu-section-input').get(0).focus();
        $('#addSectionButton').hide();
        $('#menu-section-input').focus();
    };


    document.getElementById('cancelMenuButton').onclick = function(e) {
        e.preventDefault();
        $('#addMenuButton').show();
        $('#addMenuInput').fadeOut();
    };

    document.getElementById('cancelSectionButton').onclick = function(e) {
        e.preventDefault();
        $('#addSectionButton').show();
        $('#addSectionInput').fadeOut();
    };

    //Function to be called after enter keyup event
    //Takes in event keyCode and input button to be triggered
    function handleEnterKey(keyCode, inputButton) {
      if (keyCode == 13) {
          document.getElementById(inputButton).click();
      }
    }
    //Event listeners for enter keyup for menu and menu section inputs
    document.getElementById("menu-input").addEventListener("keyup", function(event) {
      event.preventDefault();
      handleEnterKey(event.keyCode, 'confirmMenuButton');
    });
    document.getElementById("menu-section-input").addEventListener("keyup", function(event) {
      event.preventDefault();
      handleEnterKey(event.keyCode, 'confirmSectionButton');
    });

    // Function for handling option addition after user input
    // Takes in dropdown list selector and user field input
    function handleOptionInput(ddlSelector, input) {
      let inputIndex = null;
      const inputText = input.trim();
      input = input.toLowerCase().replace(/\s+/g, " ").trim();
      $(`#${ddlSelector} > option`).each(function(index, value) {
        if (input == value.text.toLowerCase()) {
          inputIndex = index;
        }
      });
      if (inputIndex === null) {
        $(`#${ddlSelector}`).prepend("<option>" + inputText + "</option>");
        document.getElementById(ddlSelector).value = inputText;
      } else {
        $(`#${ddlSelector} > option`)[inputIndex].selected = true;
      }
      $(`#${ddlSelector}`).trigger('change');
    }

    //add values to database // add to list and send with main 'submit'
    document.getElementById('confirmMenuButton').onclick = function(e) {
        e.preventDefault();
        var input = $('#addMenuInput input').val();

        if (input && input.trim() != '') {
            handleOptionInput('menu-drop', input);
            $('#addMenuInput input').val("");
            $('#addMenuButton').show();
            $('#addMenuInput').fadeOut();
        }
    };

    document.getElementById('confirmSectionButton').onclick = function(e) {
        e.preventDefault();
        var input = $('#addSectionInput input').val();

        if (input && input.trim() != '') {
            handleOptionInput('section-drop', input);
            $('#addSectionInput input').val("");
            $('#addSectionButton').show();
            $('#addSectionInput').fadeOut();
        }
    };

    $('#btn-add-menu-item').on('click', function () {
        const $this = $(this);
        if ($('#userId').val()) {
            const isAdding = !$this.hasClass('btn-danger');
            $this.toggleClass('btn-danger', isAdding);
    
            // Scroll to the button if it's switching to "add menu item" mode
            if (isAdding) {
                $('html, body').animate({ scrollTop: $this.offset().top - 15 }, 500);
                $('#btn-add-menu-item-text').text(
                    "We don't have menus for every restaurant, and those we do have are sometimes incomplete. If you don't see your menu item here, you can add them below."
                );
                $this.text('Cancel Add Menu Item');
                $('#form-add-menu-item').slideDown(100);
            } else {
                $('#btn-add-menu-item-text').text(
                    "We don't have menus for every restaurant, and those we do have are sometimes incomplete. If you don't see your menu item here, you can add them by clicking the button below."
                );
                $this.text("Add something that isn't on the menu");
                $('#form-add-menu-item').slideUp(100);
            }
        } else {
            // Trigger login prompt if the user is not logged in
            $('.show-login-btn-add-menu').click();
        }
    });
    
    
    var id_postion = ''; 
    $('#showAddedItemsBtn').on('click', function(){
        $('#btn-add-menu-item').trigger('click');
        $('#showAddedItemsBtn').fadeOut();
        $('#items-list').html('');
        //save to localstorage
        added_items.forEach((item) =>{
           saveSelection(item.entryId); //this is defined in the general-accordions-scripts file
        });
        let tmp_added_items = added_items.map(newItem => {
          return {
            item_id: newItem.entryId,
            item_name: newItem.itemName,
            item_type: "item",
            menuType: 1,
            menu_name: newItem.menu,
            parent_item_id: null,
            quantity: 1,
            rating: undefined,
            retail_price: newItem.itemPrice,
            section_name: newItem.menuSection,
            special_instructions: ""
          }
        })
       //console.log("add button clicked...going to rate..",tmp_added_items);
        rate_item_after_adding(tmp_added_items);
    })

// Removed this piece of code as it was no longer unnecessary.
// If there is no menu added, 'Main Menu' will be the default
    $('#menu-drop').change(() => {
        let selectedMenu = $('#menu-drop').val();
        $('#section-drop').html('<option class="dropdown-option" value=null>Select A Menu Section</option>');
        document.getElementById('section-drop').options[0].selected = true;
        setMenuSection(selectedMenu)
    });

    var cMenu = []
    var default_menu = []
    var default_section = []
    getMenuSection()

    function getMenuSection() {
        $.ajax({
            url: '/getMenuSection',
            method: 'POST',
            dataType: 'json',
        }).then(function(res) {
            default_menu = res.data.menus
            default_section = res.data.menusection
            render_menu_and_sections_option()
        });
    }

    function render_menu_and_sections_option(){
        $('#menu-drop').html('<option class="dropdown-option" value=null>Select A Menu</option>');
        $('#section-drop').html('<option class="dropdown-option" value=null>Select A Menu Section</option>');
        try {
            cMenu = JSON.parse($('#tree-data').val())
        } catch (error) {
            cMenu = []      
        }
        // Menu Options
        let menu_opts = {}
        _.forEach(cMenu, (item)=>{
            menu_opts[item.title] = _.size(item.children)
        })
        _.forEach(default_menu, (item)=>{
            if(!_.hasIn(menu_opts, item.name)){
                menu_opts[item.name] = 0
            }
        })
        _.forEach(menu_opts,(num, item)=>{
            $('#menu-drop').append(`<option value="${item}" class="dropdown-option">${item} (${num})</option>`);
        })
        // Section options
        let section_opts = {}
        _.forEach(cMenu, (item)=>{
            _.forEach(item.children, (elem) => {
                section_opts[elem.title] = _.size(elem.children)
            })
        })
        _.forEach(default_section, (item)=>{
            if(!_.hasIn(section_opts, item.name)){
                section_opts[item.name] = 0
            }
        })
        _.forEach(section_opts,(num, item)=>{
            $('#section-drop').append(`<option value="${item}" class="dropdown-option">${item} (${num})</option>`);
        })
        return
    }
    function setMenuSection(menu_name) {
        menu_name = _.trim(_.replace(menu_name, /\(\d+\)$/g, ''))
        // Section options
        let section_opts = {}
        _.forEach(cMenu, (item)=>{
            if(menu_name != item.title) return true;
            _.forEach(item.children, (elem) => {
                section_opts[elem.title] = _.size(elem.children)
            })
            return false
        })
        _.forEach(default_section, (item)=>{
            if(!_.hasIn(section_opts, item.name)){
                section_opts[item.name] = 0
            }
        })
        _.forEach(section_opts,(num, item)=>{
            $('#section-drop').append(`<option value="${item}" class="dropdown-option">${item} (${num})</option>`);
        })
    }

    function priceCheck (itemPrice) {
      if(itemPrice && typeof itemPrice !== "undefined" && itemPrice.trim().startsWith('$')) {
        itemPrice = itemPrice.trim().substring(1);
      }
      const decimalsCheck = parseFloat(itemPrice);
      if (isNaN(decimalsCheck)){
          return null
      }
      if (decimalsCheck % 1 != 0) {
        return decimalsCheck.toFixed(2)
      } else {
        return decimalsCheck
      }
    }
    $('#addSubmitButton, #editMenuitemButton').on('click', function(e) {
     let btnId = $(this).attr('id');
        e.preventDefault();
        if(!$('#userId').val()) return $('.show-login-btn-add-menu').click();
        $('#confirmMenuButton').trigger('click');
        $('#confirmSectionButton').trigger('click');
        var itemName = document.getElementById('item-name').value;
        var itemPrice = priceCheck(document.getElementById('item-price').value);
        var itemDesc = document.getElementById('item-desc').value;
        let menuName = $("#menu-drop").val();
        menuName = _.trim(_.replace(menuName, /\(\d+\)$/g, ''))
        let itemId = $("#meneItemsToEdit").val();
        let sectionName = $("#section-drop").val();
        sectionName = _.trim(_.replace(sectionName, /\(\d+\)$/g, ''))
        let noSalesOnTheSystem = $('#noSalesOnTheSystem').val();
        if(menuName === 'null'){
            menuName = 'Main Menu'; // set as default name`
        }
        if(sectionName === 'null'){
            sectionName = 'Other';
        }
        // this.disabled = true;
        var itemData = {
            venueId: venueId,
            venueName: venueName.toString(),
            menu: menuName,
            menuSection: sectionName,
            itemName: itemName,
            itemPrice: itemPrice,
            itemDesc: itemDesc,
            itemDesc: itemDesc,
            rateable:'yes',
        };
        if(noSalesOnTheSystem == "true") {
            console.log("nosales....rate only")
            itemData.active = "yes"
        }
        if(btnId=='addSubmitButton'){
          itemData = itemData;
        } else {
          itemData.itemId = itemId; 
          $("#addSubmitButton").show();
          $("#editMenuitemButton").hide();
        }
        if (itemName){
            document.getElementById('item-name').style.borderColor ='#f3f5f7';
            //Send item to be addedd
            $.ajax({
                url: '/postMenuItem',
                method: 'POST',
                dataType: 'json',
                data: itemData,
                error: postError

            }).then(function(data) {
              added_items = $.grep(added_items, function(e){ 
                   return e.entryId != data.entryId; 
              });
                added_items.push(data);
                id_postion = '#'+data.entryId;
                document.getElementById("addSubmitButton").disabled = false;
                ITEMS_ADDED.push({ item: data.entryId, addon: null });
                itemData['itemId'] = data.entryId;
                ITEMS_INFO.push(itemData);
                addNewItemToList(itemData);
                if(data.notify){
                    Swal.fire({
                        title: "Menu item added!",
                        text: "Scroll down to see the menu items. If you don't want this message to appear, go to My PlateRate > Account Settings and you can disable it.",
                        icon: "success",
                        allowOutsideClick: true,
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#3cb371",
                    });
                }
            });
        } else {
            Swal.fire({
                title: "All * fields are required!",
                text: "Please make sure to fill in all required fields and select or add a menu name.",
                icon: "info",
                allowOutsideClick: true,
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371",
            });
            

            if(document.getElementById('item-name').value === '') {
                document.getElementById('item-name').style.border = '2px solid red';

                // $('html, body').animate({
                //     scrollTop: $("#item-name").offset().top
                // }, 300);
            }

            document.getElementById("addSubmitButton").disabled = false;
        }
    });

    $('.add-menu-item #item-name').on('focus', function(){
      document.getElementById('item-name').style.border = '';
    });

    document.getElementById("addSubmitButton").disabled = false;
    $('#rateAddedItemsBtn').click((e) => {
        $('#rateAddedItemsBtn').text('PROCESSING...');
        $('#rateAddedItemsBtn').prop('disabled', true);
        e.preventDefault();
        if(!_.size(ITEMS_INFO)){
            Swal.fire({
                title: "No Items Added!",
                text: "Please add new item details before rating.",
                icon: "info",
                allowOutsideClick: true,
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371",
            });
            return false;
        }
        let data = {
            venueId: venueId,
            itemsInfo: ITEMS_INFO
        };
        $.ajax({
            url: '/orders/rate-items',
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
        })
        .then((res)=> {
            let checkoutId = res.data.orderId;
            let url = `/restaurant/${venue_slug || venueId}?show=Checkout-${checkoutId}`;
            window.location.href = url;
        })
        .catch((err)=>{
            $('#rateAddedItemsBtn').text('Rate These Menu Item(s)');
            $('#rateAddedItemsBtn').prop('disabled', false);
            Swal.fire({
                title: "Can't rate the item(s)",
                text: "Please try again!",
                icon: "error",
                allowOutsideClick: true,
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371",
            });  
        });
    });

    const addNewItemToList = (itemData) => {
        $('.no-items-alert').hide();
        $('#items-list').fadeIn();
        $('#rateAddedItemsBtn').fadeIn();
        $('#showAddedItemsBtn').fadeIn();
        let itemId = itemData.itemId? itemData.itemId: itemData.entryId;
        $('#items-list').find(".added-menuItem-"+itemId).remove();
        var itemPrice= "";
        if (itemData.itemPrice){
          itemPrice = "$" + itemData.itemPrice;
        }
        console.log("itemData====",itemData)
        const $itemsList = $('#items-list');
        const $itemContentDiv = $(`<div>
                <span class="orange">${itemData.itemName}</span>
                <span class="green">${itemPrice}</span>
                 <span class="green ml-2" id="menuitemid" href="javascript:void(0)" onClick="editMenuItem('${itemData.itemId}','${itemData.itemName}','${itemData.itemPrice}','${itemData.itemDesc}','${itemData.menu}','${itemData.menuSection}')"><i class="fa fa-pencil-alt" ></i></span>
                <p><span class="grey"> ${itemData.menu} -> ${itemData.menuSection} </span></p>
                
                </div>`);
        const $newItemLi = $(`<li class="added-menuItem-${itemData.itemId? itemData.itemId: itemData.entryId}"></li>`).append($itemContentDiv);
        $itemsList.append($newItemLi);
        //Clear input fields
        $('#item-name').val("");
        $('#item-price').val("");
        $('#item-desc').val("");
    };
    
    function postError(error) {
        Swal.fire({
            title: "Oops! :(",
            text: "We had a problem trying to add this item. Please try again or send an email to feedback@platerate.guru describing your issue.",
            icon: "error",
            allowOutsideClick: true,
            confirmButtonText: "Ok",
            confirmButtonColor: "#3cb371",
        });   
    }


    $(document).ready(function(){
        $('[data-toggle="tooltip"]').tooltip({
            placement : 'right',
            title:'Breakfast, Lunch, Dinner, Main Menu, Happy Hour, Drinks, Wine, etc.'
        });



    });

});

function editMenuItem(itemId, itemName, itemPrice, itemDesc, menu, menuSection){
  if(itemId){
    $('html, body').animate({ scrollTop: $(`#form-add-menu-item`).offset().top - 100 }, 800);
    $("#menu-drop").val(menu);
    $("#section-drop").val(menuSection);
    $("#item-name").val(itemName);
    $("#item-price").val(itemPrice);
    $("#item-desc").val(itemDesc);
    $("#meneItemsToEdit").val(itemId);
    $("#addSubmitButton").hide();
    $("#editMenuitemButton").show();
  }
}
